import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "../layouts/Main";
import Policy from "../pages/Policy/Policy";
import PolicySearch from '../pages/PolicySearch/PolicySearch';
import Questionnaire from "../pages/Questionnaire/Questionnaire";
import NotFound from "../pages/NotFound";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>

        <Route path="/:orgId/search" element={<Main />}>
          <Route index element={<PolicySearch />} />
        </Route>


        <Route path="/policy/:orgId/:id" element={<Main />}>
          {/* Route with vid param */}
          <Route path=":vid" element={<Policy />} />

          {/* Route without vid param */}
          <Route index element={<Policy />} />
        </Route>

        <Route path="/questionnaire" element={<Main isQuestionnaire={true} />}>
          <Route index element={<Questionnaire />} />
        </Route>


        {/* Global NotFound inside Main layout */}
        <Route path="*" element={<Main />}>
          <Route path="*" element={<NotFound />} />
        </Route>
        
      </Routes>
    </Router>
  );
};

export default AppRoutes;
